@if (files && viewDisabled === false) {
    <app-file-viewer
        [files]="files"
        [viewReadonly]="viewReadonly"
        [viewFullscreen]="viewFullscreen"
        [viewThumbnailsSize]="viewThumbnailsSize"
        [viewThumbnailsTilesSize]="viewThumbnailsTilesSize"
        [viewThumbnailsTitle]="viewThumbnailsTitle"
        [viewShowFileInfo]="viewShowFileInfo"
        [viewEditModeFlipImage]="viewEditModeFlipImage"
        [viewNoFilesText]="viewNoFilesText"
        [viewLayout]="viewLayout"
        [viewCheckbox]="viewCheckbox"
        [showViewLayoutSwitcher]="showViewLayoutSwitcher"
        [onlyCreatorCanDelete]="onlyCreatorCanDelete"
        [isAdmin]="isAdmin()"
        [enableLinks]="enableLinks"
        (deleted)="deletedEvent.emit()"
        (selectedChange)="selectedChange.emit($event)"
    />
}
@if (files && viewReadonly === false) {
    <app-file-upload class="fw-file-upload"
        [doctype]="doctype()"
        [fkId]="fkId"
        [fkName]="fkName()"
        [fkTable]="fkTable()"
        [uploadAccept]="uploadAccept"
        [uploadSelectMultiple]="uploadSelectMultiple"
        [uploadMaxFileCount]="uploadMaxFileCount"
        [uploadMaxFilesize]="uploadMaxFilesize"
        [uploadMaxSingleFilesize]="uploadMaxSingleFilesize"
        (uploaded)="uploadedEvent.emit($event); loadFiles()"
        [showDragAndDrop]="showDragAndDrop"
        [uploadDisabled]="uploadDisabled"
    />
}
